import React, { useState, Fragment, useEffect } from 'react';
import { useFormContext } from 'react-hook-form';
import { Grid, FormControlLabel, Checkbox, FormLabel } from '@material-ui/core';
import { EirAddressFinder } from './EirAddressFinder';
import { useStyle } from './style';


export const EirAddressDetails = ({ isGuest }) => {
    const { register, getValues } = useFormContext();
    const classes = useStyle();
    const [sameDeliveryAddress, setSameDeliveryAddress] = useState(false);

    useEffect(() => {
        if (!isGuest) {
            // check if billing address and delivery address are same
            if (getValues('billingAddressEirCode') == getValues('deliveryAddressEirCode')) {
                if (getValues('deliveryAddressaddressLine1') == getValues('billingAddressaddressLine1')) {
                    setSameDeliveryAddress(true);
                }
            }
        }
    }, []);

    return (
        <Fragment>
            {isGuest && (
                <div>
                    <h4 className={classes.margintop}>Delivery address</h4>
                    <Grid container spacing={2}>
                        <Grid item xs={12}>
                            <FormLabel className={classes.formLabelColor}> Please enter your eircode to autofill your address.</FormLabel>
                        </Grid>
                        <Grid item xs={12}>
                            <EirAddressFinder isDeliveryAddress />
                        </Grid>
                    </Grid>
                </div>
            )}
            {!isGuest && (
                <div>
                    <h4 className={classes.margintop}>Account address</h4>
                    <Grid container spacing={2}>
                        <Grid item xs={12}>
                            <FormLabel className={classes.formLabelColor}> Please enter your eircode to autofill your address.</FormLabel>
                        </Grid>
                        <Grid item xs={12}>
                            <EirAddressFinder />
                        </Grid>
                        <Grid item xs={12}>
                            <FormControlLabel
                                control={
                                    <Checkbox
                                        checked={sameDeliveryAddress}
                                        color="primary"
                                        id="sameDeliveryAddress"
                                        inputRef={register}
                                        name="sameDeliveryAddress"
                                        onChange={() => setSameDeliveryAddress((previousState) => !previousState)}
                                    />
                                }
                                label="Delivery address is the same as billing address."
                            />
                        </Grid>
                        {!sameDeliveryAddress && (
                            <Grid item xs={12}>
                                <h4>Delivery address</h4>
                                <EirAddressFinder isDeliveryAddress />
                            </Grid>
                        )}
                    </Grid>
                </div>


            )}

        </Fragment>
    );
}